<template>
    <div class="main">
        <Overlay :show="loading">
            <div class="loading">
                <Loading/>
                加载中
            </div>
        </Overlay>
        <div class="game" v-if="size !== 0">
            <LuckyWheel
                    ref="myLucky"
                    :width="size"
                    :height="size"
                    :prizes="prizes"
                    :blocks="blocks"
                    :buttons="buttons"
                    @start="startCallback"
                    @end="endCallback"
            />
        </div>
        <div class="tips">您当前还剩余 {{ config.balance }} 次抽奖机会</div>
        <div class="members" v-if="record.length >= 1">
            <marquee direction="up" scrollamount="2">
                <div class="members-item" v-for="(item, index) in record" :key="index">
                    <div style="flex:1">恭喜 {{item.nickname}} 抽中 {{item.name}}</div>
                    <div>x{{item.number}}</div>
                </div>
            </marquee>
        </div>
        <div class="note">
            <span class="title">活动规则</span>
            <span class="content" v-html="note()"></span>
        </div>
    </div>
</template>

<script>
import {Base64} from "js-base64";
import {Dialog, Overlay, Loading} from "vant";

export default {
    components: {Overlay, Loading},
    data() {
        return {
            // 是否加载中
            loading: true,
            // 抽奖活动信息
            config: {
                // 活动规则
                note: "",
                // 余额
                balance: 0,
            },
            size: 0,
            // 中奖记录
            record:[],
            blocks: [
                {
                    padding: '12px',
                    imgs: [{
                        src: '/assets/lottery-game/wheel/border.jpeg',
                        width: '100%',
                        height: '100%'
                    }]
                },
                {
                    padding: '10px',
                    imgs: [{
                        src: '/assets/lottery-game/wheel/border-2.png',
                        width: '100%',
                        height: '100%'
                    }]
                },
                {
                    imgs: [{
                        src: '/assets/lottery-game/wheel/background.png',
                        width: '100%',
                        height: '100%'
                    }]
                }
            ],
            prizes: [],
            buttons: [
                {
                    radius: '30%',
                    imgs: [{
                        src: '/assets/lottery-game/wheel/button.png',
                        width: '100%',
                        top: '-130%'
                    }]
                },
            ]
        }
    },
    mounted() {
        // 初始化大转盘大小
        this.size = document.documentElement.clientWidth - (20 * 2);

        // 加载活动信息
        this.loading = true;
        this.$axios.post('/api/user/lottery/lottery-activity-config/get-activity/zp', {}, {headers: {"token": this.getToken()}}).then((res) => {
            if (res.code !== 200) {
                Dialog.alert({message: res.msg ?? "请求异常，请重试", theme: 'round-button'});
                return;
            }

            if (res.data == null) {
                Dialog.alert({message: '活动未开始或已结束。', theme: 'round-button'});
                return;
            }
            this.config = res.data;

            // 设置奖励内容
            this.prizes = res.data.reward.map((item, index) => ({
                ...item,
                fonts: [{text: item.name, top: '15%', fontColor: '#DB5959'}],
                background: index % 2 === 0 ? '#F4D696' : '#FFFFFF',
                imgs: [{src: `/api/resource/resource/resource/download/${item.icon}?imgStyleName=no_watermark_compress`, width: '30px', height: '30px', top: 50}]
            }))

            // 查询中奖记录
            this.$axios.post(`/api/user/lottery/user-lottery-record/listByConfigId/${res.data.id}`, {}, {headers: {"token": this.getToken()}}).then((recordRes)=>{
                if(recordRes.code === 200) this.record = recordRes.data;
            });
        }).finally(() => {
            this.loading = false;
        });
    },
    methods: {
        /**
         * 获得描述文本信息
         * @returns {string | undefined} 活动规则信息
         */
        note() {
            return this.config?.note?.replace(/\n/g, '<br/>');
        },

        /**
         * 开始抽奖
         */
        startCallback() {
            // 调用抽奖组件的play方法开始游戏
            this.$refs.myLucky.play()
            this.$axios.post(`/api/user/lottery/lottery-activity-config/start/${this.config.id}`, {}, {headers: {"token": this.getToken()}}).then((res) => {
                if (res.code !== 200) {
                    Dialog.alert({message: res.msg ?? "请求异常，请重试", theme: 'round-button'});
                    this.$refs.myLucky.stop();
                    return;
                }

                // 更新余额
                this.config.balance = res.data.balance;

                // 设置中奖结果
                for (var item of res.data.reward) {
                    for (let i = 0; i < this.prizes.length; i++) {
                        if (this.prizes[i].id === item.id) {
                            this.$refs.myLucky.stop(i);
                            break
                        }
                    }
                }
            });
        },
        /**
         * 抽奖结束回调
         * @param prize 奖品
         */
        endCallback(prize) {
            if (!prize || !prize.name) return;
            if (prize.rewardNumber <= 0) {
                Dialog.alert({message: '很遗憾，您抽中了 ' + prize.name, theme: 'round-button'});
            } else {
                Dialog.alert({message: '恭喜您获得 ' + prize.name, theme: 'round-button'});
            }
        },
        /**
         * 获得浏览器传递的token
         * @returns {string | undefined} Token信息
         */
        getToken() {
            let token = this.$route.query?.token;
            if (token == null) {
                Dialog.alert({message: '活动加载失败', theme: 'round-button'});
                return;
            }
            return Base64.decode(token);
        },
    }
}
</script>

<style scoped>
.main {
    height: 100vh;
    width: 100%;
    background: linear-gradient(180deg, #6B1CC7 0%, #41146B 100%);
}

.loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #FFFFFF;
}

.tips {
    color: #FFF;
    text-align: center;
}

.game {
    padding: 20px;
}

.note {
    margin: 20px;
    padding: 15px;
    background: #FFFFFF;
    border-radius: 8px;
}

.note .title {
    display: block;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
}

.note .content {
    display: block;
    color: #666666;
    margin-top: 10px;
    font-size: 14px;
    text-align: left;
}

marquee {
    display: block;
    width: 100%;
    height: 30px;
    margin: 20px auto 0;
    padding: 15px;
    box-sizing: border-box;
}

marquee .members-item {
    padding: 5px 10px;
    background: rgba(0, 0, 0, 0.30);
    margin-bottom: 10px;
    border-radius: 5px;
    color: #FFF;
    display: flex;
    font-size: 14px;
}
</style>
